export const DEFAULT_DATA = [
  {
    id: 'apps',
    section: 'Apps & platforms',
    cards: [
      {
        id: 'learn',
        title: 'Learning admin',
        icon: 'school',
        color: 'teal',
        rows: [
          { label: 'URL', val: 'https://learn.litvill.com/admin', type: 'link' },
          { label: 'Login', val: 'dolores.csabai@gmail.com', type: 'text' },
          { label: 'Password', val: '1985Litvill0313', type: 'secret' }
        ]
      },
      {
        id: 'assign',
        title: 'Assignment app',
        icon: 'clipboard',
        color: 'teal',
        rows: [
          { label: 'URL', val: 'https://assignment.litvill.com/', type: 'link' },
          { label: 'Imran login', val: 'imranadmin@litvill.com', type: 'text' },
          { label: 'Imran pw', val: 'Imranadmin', type: 'secret' }
        ]
      },
      {
        id: 'hub',
        title: 'Litvill hub',
        icon: 'dashboard',
        color: 'teal',
        rows: [
          { label: 'Username', val: 'patchlesson01@gmail.com', type: 'text' },
          { label: 'Password', val: '1985Litvill$0313', type: 'secret' }
        ]
      },
      {
        id: 'github',
        title: 'GitHub',
        icon: 'code',
        color: 'gray',
        rows: [
          { label: 'Repo', val: 'https://github.com/DoloresLitvill/website2/tree/main/frontend/src', type: 'link' },
          { label: 'Password', val: 'Doli22…', type: 'secret' }
        ]
      },
      {
        id: 'flipsnack',
        title: 'Flipsnack',
        icon: 'book',
        color: 'yellow',
        rows: [
          { label: 'URL', val: 'https://www.flipsnack.com/', type: 'link' },
          { label: 'Account', val: 'Dolores account', type: 'text' }
        ]
      },
      {
        id: 'aws',
        title: 'AWS WorkMail',
        icon: 'cloud',
        color: 'gray',
        rows: [
          { label: 'URL', val: 'https://eu-west-1.console.aws.amazon.com/workmail/v2/home?region=eu-west-1#/org/m-c153522ab5ca4de7904a16453d155e29', type: 'link' }
        ]
      }
    ]
  },
  {
    id: 'email',
    section: 'Email & communication',
    cards: [
      {
        id: 'mailadmin',
        title: 'Mail admin (Zoho)',
        icon: 'settings',
        color: 'blue',
        rows: [
          { label: 'URL', val: 'https://mailadmin.zoho.com/cpanel/home.do#dashboard', type: 'link' }
        ]
      },
      {
        id: 'zohoinbox',
        title: 'Zoho inbox',
        icon: 'mail',
        color: 'blue',
        rows: [
          { label: 'URL', val: 'https://mail.zoho.com', type: 'link' },
          { label: 'Info mail', val: 'Info@litvill.com', type: 'text' },
          { label: 'Info pw', val: '1981Litvill$0824', type: 'secret' },
          { label: 'Imran mail', val: 'imran.rautan@litvill.com', type: 'text' },
          { label: 'Imran pw', val: '1993Litvill$0518', type: 'secret' }
        ]
      }
    ]
  },
  {
    id: 'payments',
    section: 'Payments',
    cards: [
      {
        id: 'phonepe',
        title: 'PhonePe',
        icon: 'payment',
        color: 'yellow',
        rows: [
          { label: 'URL', val: 'https://business.phonepe.com/login', type: 'link' },
          { label: 'Merchant ID', val: 'M220MO5IFCAP4', type: 'text' },
          { label: 'Salt key', val: '05043e5e-3b4e-4d8e-9da3-138dbea287de', type: 'secret' },
          { label: 'Salt index', val: '1 (PRODUCTION)', type: 'text' },
          { label: 'Username', val: 'Imran@litvill.com', type: 'text' },
          { label: 'Password', val: 'Doli22@Doli22', type: 'secret' }
        ]
      }
    ]
  },
  {
    id: 'tools',
    section: 'AI & tools',
    cards: [
      {
        id: 'chatgpt',
        title: 'ChatGPT',
        icon: 'psychology',
        color: 'gray',
        rows: [
          { label: 'Account', val: 'patchlesson + Doli22 / 2x', type: 'text' }
        ]
      },
      {
        id: 'mp4mp3',
        title: 'MP4 → MP3',
        icon: 'music_note',
        color: 'gray',
        rows: [
          { label: 'URL', val: 'https://ytmp3.cc/Nnht/', type: 'link' }
        ]
      }
    ]
  },
  {
    id: 'firebase',
    section: 'Firebase',
    cards: [
      {
        id: 'fb-en',
        title: 'English & Portfolio apps',
        icon: 'whatshot',
        color: 'red',
        rows: [
          { label: 'Account', val: 'dolores.csabai@gmail.com', type: 'text' }
        ]
      },
      {
        id: 'fb-se',
        title: 'SE app',
        icon: 'whatshot',
        color: 'red',
        rows: [
          { label: 'Account', val: 'Patchlesson01', type: 'text' }
        ]
      }
    ]
  },
  {
    id: 'brand',
    section: 'Brand guidelines',
    cards: [
      {
        id: 'colors',
        title: 'Corporate colors',
        icon: 'palette',
        color: 'teal',
        rows: [
          { label: 'Teal', val: '#19a4a0', type: 'color' },
          { label: 'Yellow', val: '#e8a327', type: 'color' },
          { label: 'Red', val: '#ff4747', type: 'color' }
        ]
      },
      {
        id: 'typo',
        title: 'Typography',
        icon: 'text_fields',
        color: 'gray',
        rows: [
          { label: 'Headings', val: 'Montserrat / Poppins / Lato Bold', type: 'text' },
          { label: 'Body', val: 'Lato / Open Sans', type: 'text' },
          { label: 'Spacing', val: 'Generous line spacing', type: 'text' }
        ]
      }
    ]
  }
];
